import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M22.276 10.751a1.2 1.2 0 0 1 .014 1.697l-7.573 7.7a1.2 1.2 0 0 1-1.711-1.682l5.541-5.635-15.016.126a1.2 1.2 0 0 1-.02-2.4l15.016-.126-5.634-5.541a1.2 1.2 0 0 1 1.682-1.711z"
      clipRule="evenodd"
    />
  </svg>
);
export const ArrowRIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
